import JobList from "./Pages/JobListing/JobList";
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import NavbarLogo from "./components/Header/NavbarLogo";
import Footer from "./components/Footer/Footer";
import HomePage from "./Pages/Home/HomePage";
import Router from "./Router";
import { Provider } from "react-redux";
import { store } from "./store/store";

function App() {
  return (
    // <>
    // <NavbarLogo />
    // <div>
    //   <HomePage/>
    // </div>
    // <div>
    //   <Footer />
    // </div>
    // </>
    <>
      <Provider store={store}>
        <Router />
      </Provider>
    </>
  );
}

export default App;
